import { Input, SimpleGrid } from "@chakra-ui/react";
import type { Control } from "react-hook-form";
import { Controller } from "react-hook-form";

import { ProductAdjustmentFormInput } from "../schemas/productAdjustmentSchema";
import { useGetStorage } from "@/core/storages/useCases/useGetStorage";
import { useAuth } from "@/shared/session";
import { useGetProductAdjustmentTypes } from "@/shared/core-product-adjustments";
import { Field } from "@/ui/chakra/field";
import { Select } from "@/ui/selects/Select";

interface ProductAdjustmentFormProps {
  control: Control<ProductAdjustmentFormInput>;
}

const ProductAdjustmentForm: React.FC<ProductAdjustmentFormProps> = ({
  control,
}) => {
  const { session } = useAuth();

  const { data: storages } = useGetStorage(session?.zone || "");

  const { data: productAdjustmentTypes } = useGetProductAdjustmentTypes();

  return (
    <SimpleGrid columns={{ base: 1, md: 3 }} gap={4}>
      <Controller
        control={control}
        name="productAdjustmentTypeId"
        render={({ field, fieldState: { error } }) => (
          <Field
            label="Tipo de ajuste"
            required
            invalid={!!error}
            errorText={error?.message?.toString()}
          >
            <Select
              inputId="productAdjustmentTypeId"
              placeholder="Selecciona un tipo de ajuste"
              isSearchable={false}
              options={productAdjustmentTypes?.map((type) => ({
                value: type.id,
                label: type.name,
              }))}
              value={
                productAdjustmentTypes
                  ?.filter((type) => type.id === field.value)
                  .map((type) => ({ value: type.id, label: type.name }))[0]
              }
              onChange={(option) => field.onChange(option?.value ?? "")}
            />
          </Field>
        )}
      />
      <Controller
        control={control}
        name="description"
        render={({ field, fieldState: { invalid, error } }) => (
          <Field
            label="Descripcion"
            required
            invalid={invalid}
            errorText={error?.message}
          >
            <Input
              type="text"
              placeholder="Descripcion del ajuste"
              {...field}
            />
          </Field>
        )}
      />
      <Controller
        control={control}
        name="storageId"
        render={({ field, fieldState: { error } }) => (
          <Field
            label="Bodega"
            required
            invalid={!!error}
            errorText={error?.message?.toString()}
          >
            <Select
              inputId="storageId"
              placeholder="Selecciona una bodega"
              options={storages?.map((storage) => ({
                value: storage.id,
                label: storage.name,
              }))}
              value={
                storages
                  ?.filter((storage) => storage.id === field.value)
                  .map((storage) => ({
                    value: storage.id,
                    label: storage.name,
                  }))[0]
              }
              onChange={(option) => field.onChange(option?.value ?? "")}
            />
          </Field>
        )}
      />
    </SimpleGrid>
  );
};

export default ProductAdjustmentForm;
